import { node } from "~/util/dom";
import { createPremiumIconWithTooltip } from "~/util/premium";

interface IMyMapsToggle {
	text: string;
	checked?: boolean;
	isPremiumUser?: boolean;
	onChange?: (checked: boolean) => void;
	onClick?: () => void;
}

export function createMyMapsToggle({
	text = "",
	checked = false,
	isPremiumUser = false,
	onChange = () => {},
	onClick,
}: IMyMapsToggle) {
	const container = node("div", { className: "mymapsToggle" });
	const inner = node("div", { className: "mymapsToggle__inner" });
	const toggle = node("mapy-toggle");
	const alwaysOnMapText = node("p", {}, text);

	toggle.checked = checked;
	toggle.addEventListener("change", () => {
		onChange(toggle.checked);
	});
	inner.append(toggle, alwaysOnMapText);
	alwaysOnMapText.addEventListener("click", () => {
		toggle.checked = !toggle.checked;
		onChange(toggle.checked);
	});

	if (!isPremiumUser) {
		const premiumIcon = createPremiumIconWithTooltip();

		toggle.disabled = true;
		inner.appendChild(premiumIcon);
	}

	if (onClick) {
		inner.addEventListener("click", () => {
			onClick();
		});
	}

	container.append(inner);

	return container;
}
